import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // Field Access Roles
    { value: 'fields:studentMedical', label: 'Student Medical' },
    { value: 'fields:studentSensitive', label: 'Student Sensitive' },
    { value: 'fields:caregiverMedical', label: 'Caregiver Medical' },
    { value: 'fields:caregiverSensitive', label: 'Caregiver Sensitive' },
    { value: 'fields:staffMedical', label: 'Staff Medical' },
    { value: 'fields:staffSensitive', label: 'Staff Sensitive' },
  ],
});
